// Extrae un string de error de cualquier respuesta axios del backend.
// El proyecto tiene varios formatos de error:
//   - sendError(res, 'KEY')           → { error: { message: "..." } }
//   - res.status(400).send({error})   → { error: "..." }
//   - res.status(500).send({message}) → { message: "..." }
//   - errores de red                  → err.message
//
// Siempre devuelve un string (nunca un objeto) para que React lo pueda renderizar.

export function extractError(err, fallback = 'Error desconocido') {
  if (!err) return fallback;

  // Si nos pasaron directamente un string
  if (typeof err === 'string') return err;

  const data = err?.response?.data;

  if (data) {
    if (typeof data === 'string') return data;

    // { error: "string" }
    if (typeof data.error === 'string') return data.error;

    // { error: { message: "string" } }
    if (data.error && typeof data.error === 'object') {
      if (typeof data.error.message === 'string') return data.error.message;
    }

    // { message: "string" }
    if (typeof data.message === 'string') return data.message;
  }

  if (typeof err.message === 'string') return err.message;

  return fallback;
}
